import { useTranslation } from 'react-i18next'
import i18next from 'i18next'
import { useQuery } from '@apollo/client'
import { useNavigate } from 'router'
import { Code, Site, CopyIcon } from './CardStyles'

import { OPERATION_FIND_COUPON_H3 } from '../operations-gql/queries'
import { formatValidity } from 'utils'
import { toast } from 'components/global/CUK/Toast/Toast'

import { Stack, Tooltip } from '@mui/material'

import FirstUse, { PeriodUse } from './Widgets'

import CardPreview, { CardBlockInfo, CardBody, CardHeader } from 'packages/ui/CardPreview'
import { Status } from '../Table/config-columns-h3'
import { trackEvent } from 'analytics'

const Header = ({ coupon }) => {
  const { t } = useTranslation()
  
  const handleCopyCode = () => {
    navigator.clipboard.writeText(coupon.code)
    trackEvent('copy_code', { code_type: 'h3' })
    toast.success(t('coupons.actions.copy_code.toast_message'))
  }

  return (
    <CardHeader>
      <Stack direction="column" alignItems="center" gap={3}>
        <Status coupon={coupon} />
        <Site>{coupon.site.name}</Site>
        {coupon.valid ? (
          <Tooltip title={t('coupons.actions.copy_code.tooltip_message')} arrow>
            <Code onClick={handleCopyCode}>
              <CopyIcon className="fa-light fa-copy" />
              <span>{coupon.code}</span>
            </Code>
          </Tooltip>
        ) : (
          <Code>
            <span>{coupon.code}</span>
          </Code>
        )}
      </Stack>
    </CardHeader>
  )
}

const Body = ({ coupon, localDateOptions }) => {
  const { t } = useTranslation()
  const devicesNumber = coupon.number_of_devices === -1 
    ? t('coupons.card.infinite_usage') 
    : coupon.number_of_devices

  return (
    <CardBody grid>
      <CardBlockInfo title={t('coupons.card.offer')} subtitle={coupon.offer?.name} />
      <CardBlockInfo title={'coupons.card.validity'} subtitle={formatValidity(coupon.validity_period, t).join(' ')} />
      <CardBlockInfo
        title={t('coupons.card.first_provisioning_date')}
        subtitle={<FirstUse coupon={coupon} localDateOptions={localDateOptions} />}
      />
      <CardBlockInfo title={t('coupons.card.period')} subtitle={<PeriodUse coupon={coupon} />} />
      <CardBlockInfo
        title={t('coupons.card.creation_date')}
        subtitle={new Date(coupon.created_at).toLocaleDateString(i18next.language, localDateOptions)}
      />
      <CardBlockInfo title={t('coupons.card.devices_number')} subtitle={devicesNumber} />
      <CardBlockInfo title={t('coupons.card.phone')} subtitle={coupon.phone} />
      <CardBlockInfo title={t('coupons.card.description')} subtitle={coupon.description} />
    </CardBody>
  )
}

const CardH3 = ({ id, localDateOptions, isModal = false }) => {
  const { t } = useTranslation()
  const { loading, error, data } = useQuery(OPERATION_FIND_COUPON_H3, {
    variables: { id: +id }
  })
  const navigate = useNavigate()

  return (
    <CardPreview
      title={t('coupons.card.title')}
      loading={loading}
      error={error ? t('shared.error') : null}
      onClose={() => navigate({ pathname: '..' })}
      hideHeader={isModal}
    >
      {data && (
        <>
          <Header coupon={data.coupon} />
          <Body coupon={data.coupon} localDateOptions={localDateOptions} />
        </>
      )}
    </CardPreview>
  )
}
export default CardH3
